import { Icon } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useCloseOnline from '../../../hooks/useCloseOnline';
import OfferAction from './OfferAction';

interface Props {
  offerId?: string;
  offerIds?: string[];
}

const OfferCloseOnline: React.FC<Props> = ({ offerId, offerIds }) => {
  const { t } = useTranslation();
  const { handleCloseOnline, isLoading } = useCloseOnline();
  return (
    <OfferAction
      icon={<Icon name="GeneralNavigationShoppingBag" />}
      isPrimary
      onClick={() => handleCloseOnline(offerIds || offerId!)}
      isLoading={isLoading}
      isDisabled={!offerId && !offerIds?.length}
    >
      {t('SALES-CONVERSATION_OFFERS_SINGLE-OFFER_ACTIONS_CLOSE-ONLINE')}
    </OfferAction>
  );
};

export default OfferCloseOnline;
